// src/App.jsx
// Point d'entrée SOLSTICE v68
// Le bandeau utilisateur (📥 👥 🚪) est géré dans AppPrincipale.jsx

import { useState, useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import LoginPage from './pages/LoginPage'
import SetPasswordPage from './pages/SetPasswordPage'
import TwoFactorPage from './pages/TwoFactorPage'
import AppPrincipale from './AppPrincipale'
import { supabase } from './supabase'

function AppRouter() {
  const { user, loading } = useAuth()
  const [isInviteFlow, setIsInviteFlow] = useState(false)
  const [flowReady,    setFlowReady]    = useState(false)

  useEffect(() => {
    const flow = sessionStorage.getItem('_auth_flow')
    if (flow === 'invite' || flow === 'recovery') {
      sessionStorage.removeItem('_auth_flow')
      setIsInviteFlow(true)
    }
    setFlowReady(true)
  }, [])

  // 2FA : vérifié si sessionStorage contient l'email de l'utilisateur courant
  const twoFaVerified = user ? sessionStorage.getItem('2fa_done') === user.email?.toLowerCase() : false

  const handleLogout2FA = async () => {
    sessionStorage.removeItem('2fa_done')
    sessionStorage.removeItem('2fa_awaiting')
    await supabase.auth.signOut()
  }

  if (loading || !flowReady) return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Bricolage Grotesque', sans-serif",
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          fontSize: '2rem', fontWeight: 800,
          background: 'linear-gradient(135deg, #FF6B35, #00D4AA)',
          WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          marginBottom: '1rem',
        }}>
          ☀️ SOLSTICE
        </div>
        <div style={{ color: '#64748B', fontSize: '0.9rem' }}>Chargement…</div>
      </div>
    </div>
  )

  if (!user) {
    const awaiting = sessionStorage.getItem('2fa_awaiting')
    if (awaiting) {
      return (
        <TwoFactorPage
          email={awaiting}
          onVerified={() => {
            sessionStorage.setItem('2fa_done', awaiting.toLowerCase())
            sessionStorage.removeItem('2fa_awaiting')
          }}
          onLogout={() => {
            sessionStorage.removeItem('2fa_awaiting')
            sessionStorage.removeItem('2fa_done')
          }}
        />
      )
    }
    return <LoginPage />
  }

  if (isInviteFlow || user.user_metadata?.first_login === true) {
    return <SetPasswordPage onDone={() => { setIsInviteFlow(false); window.location.hash = '' }} />
  }

  if (twoFaVerified) return <AppPrincipale />

  // Définir 2fa_awaiting avant le render (doit être présent quand signOut fire)
  if (!sessionStorage.getItem('2fa_awaiting')) {
    sessionStorage.setItem('2fa_awaiting', user.email?.toLowerCase())
  }
  return (
    <TwoFactorPage
      email={user.email}
      onVerified={() => {
        sessionStorage.setItem('2fa_done', user.email?.toLowerCase())
        sessionStorage.removeItem('2fa_awaiting')
      }}
      onLogout={handleLogout2FA}
    />
  )
}

const FallbackErreur = ({ error, resetError }) => (
  <div style={{
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0F172A 0%, #1E293B 100%)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontFamily: "'Bricolage Grotesque', sans-serif",
  }}>
    <div style={{ textAlign: 'center', maxWidth: 480, padding: '2rem' }}>
      <div style={{
        fontSize: '2rem', fontWeight: 800,
        background: 'linear-gradient(135deg, #FF6B35, #00D4AA)',
        WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
        marginBottom: '1rem',
      }}>
        ☀️ SOLSTICE
      </div>
      <p style={{ color: '#F87171', fontWeight: 600, marginBottom: '0.5rem' }}>
        Une erreur inattendue s'est produite.
      </p>
      <p style={{ color: '#64748B', fontSize: '0.8rem', marginBottom: '1.5rem' }}>
        {error?.message}
      </p>
      <button
        onClick={resetError}
        style={{
          background: 'linear-gradient(135deg, #FF6B35, #00D4AA)',
          border: 'none', borderRadius: 8, padding: '0.6rem 1.5rem',
          color: '#fff', fontWeight: 700, cursor: 'pointer',
        }}
      >
        Réessayer
      </button>
    </div>
  </div>
)

export default function App() {
  return (
    <Sentry.ErrorBoundary fallback={FallbackErreur} showDialog={false}>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </Sentry.ErrorBoundary>
  )
}
